export default __webpack_public_path__ + "static/media/78.6ff6ef30.jpeg";